import { CSSProperties, FC, useMemo } from "react";
import "./JumpingEmotes.scss";

const getStyle = (x: number, scale = 1, heightMultiplier = 1) => {
    const pctX = (x - 50) / 100;
    const height = Math.abs(heightMultiplier * (1 + 200 * pctX * pctX));
    return {
        "--x": x,
        "--scale": scale,
        "--heightMultiplier": height,
        "--animationDelay": Math.random() * 5000,
        "--rotations": -2 + Math.random() * 4,
    } as CSSProperties;
}

const possibleEmotes = [
    "https://static-cdn.jtvnw.net/emoticons/v2/302127106/default/dark/1.0",
    "https://static-cdn.jtvnw.net/emoticons/v2/302127105/default/dark/1.0",
    "https://static-cdn.jtvnw.net/emoticons/v2/307888565/default/dark/1.0",
    "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0f923d008d0b4073b02280cd414833f4/default/dark/1.0",
    "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_f10abe1778344da38a1997836e45d909/default/dark/1.0",
]

const getRandomEmote = () => {
    return possibleEmotes[~~(Math.random() * possibleEmotes.length)];
}
export const JumpingEmotes: FC = () => {
    const emotes = useMemo(() => {
        const e = [];
        const countEmotes = 20;
        for (let i = 0; i < countEmotes; i++) {
            const x = 5 + 0.9 * i * 100/countEmotes;
            e.push(
                <img
                    key={i}
                    className="jumping-emote"
                    src={getRandomEmote()}
                    style={getStyle(x, 0.7 + Math.random() * 0.3)}
                />
            );
        }

        return e;
    }, []);
    return (
        <div className="jumping-emotes">
            {emotes}
        </div>
    );
}